// IndexedDB database — PSD §3.5, P1.16. Persistence layer.

import { openDB, type IDBPDatabase } from 'idb';

const DB_NAME = 'backsolve';
const DB_VERSION = 1;

export async function openBacksolveDB(): Promise<IDBPDatabase> {
  return openDB(DB_NAME, DB_VERSION, {
    upgrade(db) {
      if (!db.objectStoreNames.contains('capTableSnapshots')) {
        db.createObjectStore('capTableSnapshots', { keyPath: 'id' });
      }
      if (!db.objectStoreNames.contains('valuations')) {
        const store = db.createObjectStore('valuations', { keyPath: 'valuationId' });
        store.createIndex('byEntity', 'entityName');
        store.createIndex('byStatus', 'status');
        store.createIndex('byDate', 'compliance.valuationDate');
      }
      if (!db.objectStoreNames.contains('auditTrail')) {
        const store = db.createObjectStore('auditTrail', { keyPath: 'eventId' });
        store.createIndex('byValuation', 'valuationId');
      }
    },
  });
}

let dbPromise: Promise<IDBPDatabase> | null = null;

export function getDB(): Promise<IDBPDatabase> {
  if (!dbPromise) {
    dbPromise = openBacksolveDB();
  }
  return dbPromise;
}
